module.exports = function () {
  /**
  * @file core/log.js
  * @author
  * @description 端能力统计功能，上报信息：来源、时间、能力名
  */
  var userAgent = navigator.userAgent; // 获取 os

  function getOS() {
    var result = '';

    if (/\biPhone\b|\biPad\b/.test(userAgent) && !/android/i.test(userAgent)) {
      result = 'ios';
    } else if (/android/i.test(userAgent)) {
      result = 'android';
    } else if (/windows/i.test(userAgent)) {
      result = 'windows';
    } // 返回结果


    return result;
  } // 获取 boxVersion


  function getBoxV() {
    var result = '';
    var a = '';

    if (a == /([\d+.]+)_(?:diordna|enohpi)_/.exec(userAgent)) {
      try {
        a = a[1].split('.');
        a = a.reverse(); // a.length = 2; // 有段时间怕版本太多，给限制住了。

        result = a.join('.');
      } catch (e) {
        console.log('获取ios手百版本无匹配，原始字符为：' + userAgent);
      }
    } else if (a == /baiduboxapp\/([\d]+([.][\d]+){1,3})/.exec(userAgent)) {
      try {
        result = a[1];
      } catch (e) {
        console.log('获取android手百版本无匹配，原始字符为：' + userAgent);
      }
    }

    return result;
  } // 获取简版的boxVersion，即根据 8.1.1.9 获取 8.1，失败返回原字符串


  function getSimpleBoxV() {
    var v = getBoxV();

    if (v == null || typeof v !== 'string') {
      // 参数格式不正确
      return v;
    }

    var reg = /^\d+\.\d+/;
    var arr = '';

    if (reg.test(v)) {
      arr = v.match(reg);

      if (arr.length) {
        return arr[0];
      }
    }

    return v;
  }

  function tcbox(data) {
    if (!data.common || !data.cusData || !data.type) {
      return;
    }

    var commonData = data.common;
    var cusData = data.cusData; // console.log(data);
    // 用于获取对应类型的data.actionid

    var actionid = {
      'pv': 1,
      'jserr': 1,
      'event': 2,
      'custom_err': 1,
      'perf': 2
    };
    var logtype = {
      'pv': 1,
      'jserr': 2,
      'event': 3,
      'custom_err': 4,
      'perf': 5
    }; // 用于获取对应类型的data.actiondata.type

    var actiondatatype = function (data) {
      // 0—事件类  1—流类型
      var type = {
        'pv': 0,
        'jserr': 0,
        // event: 0, 0, c_xxx:0 t_xxx:
        'custom_err': 0,
        'perf': 1
      };

      if (data.type === 'event') {
        if (data.cusData.evt && data.cusData.evt.match(/^c_\w*/)) {
          // type.event = 0;
          return 0;
        } else {
          return 1;
        }
      }

      return type[data.type];
    };

    var protocol = window.location.protocol;

    if (protocol !== 'http:') {
      protocol = 'https:';
    }

    var GIF_URI = protocol + '//m.baidu.com/tcbox?service=bdbox&action=pblog&'; // tcboxdata.actiondata，日志类型：0—事件类  1—流类型

    var actiondataCommon = {
      'type': actiondatatype(data),
      //事件上报的时间戳
      'timestamp': +Date.now(),
      id: 10092,
      //具体内容字段
      'content': {
        from: 'whole',
        //手百整体业务
        type: '0',
        //端能力返回status非0
        value: '0',
        page: cusData.id,
        source: cusData.name,
        platform: commonData.platform
      }
    };

    if (cusData.errCode) {
      actiondataCommon.content.type = '-1';
      actiondataCommon.content.value = cusData.errCode;
    }

    if (actiondatatype(data)) {
      if (data.type === 'event') {
        // 自定义打点
        actiondataCommon.content.duration = parseInt(cusData.msg) / 1000;
      } else {
        var arrayTemp = [];
        var objectTemp = {
          id: '',
          d: '',
          info: {}
        };

        for (var each in cusData) {
          objectTemp.id = each;
          objectTemp.d = cusData[each];
          arrayTemp.push(objectTemp);
          objectTemp = {
            id: '',
            d: '',
            info: {}
          };
        }

        actiondataCommon.content.part = arrayTemp;
      }
    } // 整型: appid, dataid, cateid, actionid


    var tcboxdata = {
      'appid': 1,
      //手机百度
      'dataid': 2,
      //区分1---sdk客户端  2---JS  3---SERVER
      'cateid': 99,
      // 区分业务 卡片、小说、视频…   26是掣电
      'actionid': actionid[data.type],
      //区分行为  1---PV  2---Js报错  3---自定义事件  4---自定义错误  5---性能     cateid和actionid的取值分配已更新 wiki：http://wiki.baidu.com/pages/viewpage.action?pageId=128470960
      'actiontype': '0',
      //区分主动/被动行为，1---主动  0---被动
      'actiondata': actiondataCommon //业务具体数据，json格式，具体字段规范参见2.1

    }; // 发送请求

    GIF_URI += 'data=' + encodeURIComponent(JSON.stringify(tcboxdata));
    setTimeout(function () {
      var img = document.createElement('img');

      img.onload = img.onerror = img.onabort = function () {
        // 测试输出用
        // console.log(JSON.stringify({
        //     'img': img.src,
        //     'type': data.type,
        //     'tcboxdata': tcboxdata
        // }));
        img = null;
      };

      img.src = GIF_URI;
    });
  }

  return window.log = function (id, type, info) {
    var common = {
      'hybridVersion': window.hybridVersion || '0',
      'platform': getOS() || 'other',
      'boxV': getSimpleBoxV() || '0',
      'boxVersion': getBoxV() || '0',
      'page_id': '301_' + id,
      'network': '',
      'cuid': ''
    };
    var cusData = {
      'evt': 'c_' + type,
      'msg': 'jssdk_' + type,
      'name': type,
      'id': id
    };

    if (info) {
      cusData.errCode = info.errCode + '';
    }

    tcbox({
      'common': common,
      'cusData': cusData,
      'type': 'event'
    });
  };
}();